module.exports = __webpack_public_path__ + "static/media/Control on investment.699061a1.png";